module.exports = __webpack_public_path__ + "static/media/Subscription.0d3a6cea.svg";